module.exports = __webpack_public_path__ + "img/hero-network-no-roles.b75e7d3a.png";